export const appSaveIcon = {
  data: `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24.4444 12H13.7778C12.7911 12 12 12.8 12 13.7778V26.2222C12 27.2 12.7911 28 13.7778 28H26.2222C27.2 28 28 27.2 28 26.2222V15.5556L24.4444 12ZM26.2222 26.2222H13.7778V13.7778H23.7067L26.2222 16.2933V26.2222ZM20 20C18.5244 20 17.3333 21.1911 17.3333 22.6667C17.3333 24.1422 18.5244 25.3333 20 25.3333C21.4756 25.3333 22.6667 24.1422 22.6667 22.6667C22.6667 21.1911 21.4756 20 20 20ZM14.6667 14.6667H22.6667V18.2222H14.6667V14.6667Z"
          fill="#4F4F4F"/>
</svg>
`,
  name: 'save',
};
